import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=a997ff30&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=a997ff30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a997ff30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a997ff30')) {
      api.createRecord('a997ff30', component.options)
    } else {
      api.reload('a997ff30', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=a997ff30&scoped=true&", function () {
      api.rerender('a997ff30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2c2yJ42po6XX0/JS/comp/PopupDialog.vue"
export default component.exports